import { Link } from "react-router-dom";

export const HomeNoticeItem = ({ notice }) => {
    //메인 이미지가 있으면 이미지만 표시
    const fileUrl = (notice.image?.startsWith('http://')) ? `${notice.image}` : notice.image;
    return (
        <div className="slide_item">
            <Link to={`/${window.schoolCode}/notice/${notice.id}`}>
                <div className="video_thumb">
                    <img src={fileUrl} alt={`${notice.title} 첨부사진`} />
                </div>
            </Link>
        </div>
    );
}